import { NavLink, Outlet } from 'react-router-dom';

import { webConfig } from '../config/env';
import { cx } from '../lib/class-names';
import { ROUTES } from '../routes/paths';

import styles from './RootLayout.module.css';

interface NavItem {
  to: string;
  label: string;
}

const NAV_ITEMS: NavItem[] = [
  { to: ROUTES.home, label: 'Home' },
  { to: ROUTES.status, label: 'API status' },
];

function navLinkClassName({ isActive }: { isActive: boolean }): string {
  return cx(styles.navLink, isActive && styles.navLinkActive);
}

/**
 * Application shell.
 *
 * Uses landmark elements (`header`, `nav`, `main`, `footer`) and a skip link
 * so keyboard and screen-reader users can bypass the navigation.
 */
export function RootLayout() {
  return (
    <div className={styles.shell}>
      <a className={styles.skipLink} href="#main-content">
        Skip to main content
      </a>

      <header className={styles.header}>
        <div className={styles.headerInner}>
          <NavLink to={ROUTES.home} className={styles.brand}>
            {webConfig.appName}
          </NavLink>

          <nav aria-label="Primary">
            <ul className={styles.navList}>
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <NavLink to={item.to} className={navLinkClassName} end>
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>

      <main id="main-content" className={styles.main} tabIndex={-1}>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <span>{webConfig.appName}</span>
          <span>Environment: {webConfig.appEnv}</span>
        </div>
      </footer>
    </div>
  );
}
